import { createFileRoute, redirect } from '@tanstack/react-router';

import { REPORT_TAB } from '@/features/reports/tabs';

/*
  The app version log is Reports' App usage tab since ALS-160 (Franka, 15 Sep 2026). The address
  stays so the link in QA notes and bookmarks still lands, and lands on the tab, replacing itself
  in the history so Back does not bounce through it.
*/
export const Route = createFileRoute('/_app/app-version-log')({
    beforeLoad: () => {
        throw redirect({ to: '/reports', search: { tab: REPORT_TAB.AppUsage }, replace: true });
    },
});
